import React from 'react'
import RefundTracker from './RefundTracker';
import { useGetPermissions } from 'layouts/customHook';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';

const RefundTrackerSetup = () => {
    const userPermissions = useGetPermissions("refundTracker");
    return (
        userPermissions
            ? <RefundTracker userPermissions={userPermissions} />
            : <PermisionDenied />
    )
}

export default RefundTrackerSetup;